<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">Financier</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
        </v-flex>
        <v-flex xs12 >
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row align-center>
                <v-flex xs3 sm2 md1>
                  <v-chip label color="teal lighten-2" class="py-2 icon-chip">
                    <v-icon dark>fas fa-euro-sign</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs8>
                  <div class="headline">{{ indicateurFinancier('tresorerieGroupe')*1000 | currency}}</div>
                  <div class="subheading grey--text text--darken-1">Trésorerie groupe</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 lg7>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs3 sm2 md1 lg2>
                  <v-chip label color="red lighten-2" class="py-2 icon-chip">
                    <v-icon dark>fas fa-hand-holding-usd</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs9>
                  <div class="headline">Décaissements</div>
                </v-flex>
                <v-flex xs6 sm3 class="text-xs-center pa-3">
                  <div class="subheading">{{ lastUpdate.getFullYear() -1 }}</div>
                  <pie-chart :data="chartData0" :options="decaissementsOptions"></pie-chart>
                </v-flex>
                <v-flex xs6 sm3 class="text-xs-center pa-3">
                  <div class="subheading">{{ lastUpdate.getFullYear() }}</div>
                  <pie-chart :data="chartData1" :options="decaissementsOptions"></pie-chart>
                </v-flex>
                <v-flex xs6 sm3 class="text-xs-center pa-3">
                  <div class="subheading">{{ lastUpdate.getFullYear() + 1 }}</div>
                  <pie-chart :data="chartData2" :options="decaissementsOptions"></pie-chart>
                </v-flex>
                <v-flex xs6 sm3 class="text-xs-center pa-3">
                  <div class="subheading">{{ lastUpdate.getFullYear() + 2 }}</div>
                  <pie-chart :data="chartData3" :options="decaissementsOptions"></pie-chart>
                </v-flex>
                <v-flex xs12>
                  <ul class="legend">
                    <li v-for="(lib, index) in this.decaissementsLibelles(3)" :key="index">
                      <span :style="{'background-color': decaissementsColors[index]}" class="legend-color"></span>{{ lib }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 lg5>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs3 sm2 md1 lg2>
                  <v-chip label color="orange lighten-2" class="py-2 icon-chip">
                    <v-icon dark>fas fa-chart-line</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs9>
                  <div class="headline">Rentabilité</div>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                  <horizontal-bar-chart :data="rentaData" :options="rentaOptions"></horizontal-bar-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import PieChart from '@/components/charts/PieChart'
import HorizontalBarChart from '@/components/charts/HorizontalBarChart'

export default {
  name: 'Financier',
  components: {
    PieChart, HorizontalBarChart
  },
  data(){
    return {
      decaissementsColors : [
        '#5b9bd5',
        '#ed7d31',
        '#a5a5a5',
        '#ffc000',
        '#7030a0',
        '#70ad47',
        '#255e91'
      ],
      decaissementsOptions: {
        legend: {
          display: false,
        }
      },
      rentaOptions: {
        legend: {
          display: false,
        },
      }
    }
  },
  computed: {
    ...mapState(['lastUpdate']),
    ...mapGetters([
      'indicateurFinancier', 'serieFinancier', 'decaissementsLibelles', 'decaissementsValues', 'rentabilite', 'rentaLibelles', 'rentaTaux', 'rentaNet'
    ]),
    chartData0() {
      return {
        labels:  this.decaissementsLibelles(0),
        datasets: [
          {
            data: this.decaissementsValues(0),
            backgroundColor: this.decaissementsColors
          },
        ]
      }
    },
    chartData1() {
      return {
        labels:  this.decaissementsLibelles(1),
        datasets: [
          {
            data: this.decaissementsValues(1),
            backgroundColor: this.decaissementsColors
          },
        ]
      }
    },
    chartData2() {
      return {
        labels:  this.decaissementsLibelles(2),
        datasets: [
          {
            data: this.decaissementsValues(2),
            backgroundColor: this.decaissementsColors
          },
        ]
      }
    },
    chartData3() {
      return {
        labels:  this.decaissementsLibelles(3),
        datasets: [
          {
            data: this.decaissementsValues(3),
            backgroundColor: this.decaissementsColors
          },
        ]
      }
    },
    rentaData() {
      return {
        labels:  this.rentaLibelles(),
        datasets: [
          {
            data: this.rentaTaux(),
            backgroundColor: [
              '#70ad47',
              '#009688',
              '#5b9bd5',
              '#255e91',
              '#7030a0',
              '#a5a5a5',
              '#795548',
              '#ffc000',
              '#ed7d31',
              '#E53935',
              '#E91E63',
            ]
          },
        ]
      }
    },
  }
}
</script>

<style scoped>

</style>
